import React from 'react';
import { connect } from 'react-redux';
import * as StyledFooter from './footer.styles';
import { ReactComponent as IconLogoLight } from '../../figures/logo-light.svg';
import { ReactComponent as IconGraphics } from '../../figures/graphics.svg';
import { Columns, Column } from '../base';

const Footer = ({
	loading,
	navigation
}) => (
	<StyledFooter.Footer hidden={loading}>
		<StyledFooter.LeftWrapper>
			<StyledFooter.DesktopLogoLink to="/">
				<IconLogoLight />
			</StyledFooter.DesktopLogoLink>
			<StyledFooter.FooterImage />
		</StyledFooter.LeftWrapper>
		<StyledFooter.Nav>
			<Columns gapless>
				<Column tablet={1 / 2} gapless flex="1 0 1">
					{
							navigation !== null && navigation[0].Children.map(child => !child.Hidden && (
								<StyledFooter.NavItem key={child.Id}>
									<StyledFooter.NavItemLink to={child.Url}>
										{child.Name}
									</StyledFooter.NavItemLink>
								</StyledFooter.NavItem>
							))
						}
				</Column>
			</Columns>
		</StyledFooter.Nav>
		<StyledFooter.GraphicsWrapper>
			<IconGraphics />
		</StyledFooter.GraphicsWrapper>
	</StyledFooter.Footer>
);

const mapStateToProps = ({ pageReducer, navigationReducer }) => {
	return {
		loading: pageReducer.loading,
		navigation: navigationReducer.navigation
	};
};

export default connect(mapStateToProps)(Footer);
